<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M15.75 12.15A5.85 5.85 0 0 1 9.9 18a5.925 5.925 0 0 1-5.499-3.726L2.079 8.433a.896.896 0 0 1 1.098-1.188l.342.108c.396.108.711.405.864.783l1.242 3.114h.225v-9c0-.495.405-.9.9-.9s.9.405.9.9V9h.9V.9c0-.495.405-.9.9-.9s.9.405.9.9V9h.9V2.025c0-.495.405-.9.9-.9s.9.405.9.9V9h.9V4.5c0-.495.405-.9.9-.9s.9.405.9.9v7.65Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
